import {
  useState,
  forwardRef,
  useImperativeHandle,
} from 'react'
import PropTypes from 'prop-types'

export const Togglable = forwardRef((props, refs) => {
  const [visible, setVisible] = useState(false)

  const hideWhenVisible = {
    display: visible ? 'none' : '',
  }
  const showWhenVisible = {
    display: visible ? '' : 'none',
    gap: '1rem',
    alignItems: 'center',
  }

  const toggleVisibility = () => {
    setVisible(!visible)
  }

  useImperativeHandle(refs, () => {
    return {
      toggleVisibility,
    }
  })

  const handleClick = e => {
    e.stopPropagation()
    toggleVisibility()
  }

  return (
    <div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '1rem',
        }}
      >
        <a
          style={{ cursor: 'pointer' }}
          onClick={handleClick}
        >
          <h3 className="row" style={{ padding: '0' }}>
            <span
              style={hideWhenVisible}
              className="material-icons rem1-5"
            >
              add
            </span>
            <span
              style={showWhenVisible}
              className="material-icons rem1-5"
            >
              remove
            </span>

            {props.label}
          </h3>
        </a>

        {props.visibleContent}
      </div>
      <div style={hideWhenVisible}></div>
      <div
        style={showWhenVisible}
        className="togglableContent"
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '1rem',
            paddingBlock: '1rem',
          }}
        >
          {props.children}
        </div>
      </div>
    </div>
  )
})

Togglable.displayName = 'Togglable'

Togglable.propTypes = {
  //label: PropTypes.isRequired,
}

export default Togglable
